module.exports = __webpack_public_path__ + "static/media/donna-mobile.1614cb6e.jpg";